import { render, staticRenderFns } from "./videoForm.vue?vue&type=template&id=a2a4be08&scoped=true&"
import script from "./videoForm.vue?vue&type=script&lang=js&"
export * from "./videoForm.vue?vue&type=script&lang=js&"
import style0 from "./videoForm.vue?vue&type=style&index=0&id=a2a4be08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a4be08",
  null
  
)

export default component.exports